import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  }
]

const router = new VueRouter({
  routes
})

// 路由变更时通知 Android
router.afterEach((to, from) => {
  console.log('【Vue】路由变更:', to.path)
  if (window.$App && window.$App.onPageChanged) {
    try {
      window.$App.onPageChanged(to.path)
    } catch (e) {
      console.log('【Vue】通知Android失败:', e)
    }
  }
})

export default router